var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "modal",
      staticClass: "modal fade",
      attrs: {
        id: "galleryModal",
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": "galleryModalLabel",
        "aria-hidden": "true",
        "data-backdrop": "static",
        "data-keyboard": "false",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-xl gallery-modal__dialog",
          attrs: { role: "document" },
        },
        [
          _c("div", { staticClass: "modal-content gallery-modal__content" }, [
            _c("div", { staticClass: "modal-header gallery-modal__header" }, [
              _vm._m(0),
              _vm._v(" "),
              _vm.typeKeys.length > 0
                ? _c(
                    "div",
                    { staticClass: "gallery-modal__typebar" },
                    _vm._l(_vm.typeKeys, function (key) {
                      return _c(
                        "button",
                        {
                          key: key,
                          staticClass: "gallery-modal__type-tab",
                          class: {
                            "gallery-modal__type-tab--active":
                              _vm.activeTypeKey === key,
                          },
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.setTypeKey(key)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.typeLabel(key)) +
                              "\n          "
                          ),
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "gallery-modal__access-row" }, [
                _c("span", { staticClass: "gallery-modal__filterlabel" }, [
                  _vm._v("Template Access"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "gallery-modal__style-options" }, [
                  _c(
                    "button",
                    {
                      staticClass: "gallery-modal__style-option",
                      class: {
                        "gallery-modal__style-option--active":
                          _vm.accessFilters.includes("global"),
                      },
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.toggleAccessFilter("global")
                        },
                      },
                    },
                    [_vm._v("\n              Global\n            ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "gallery-modal__style-option",
                      class: {
                        "gallery-modal__style-option--active":
                          _vm.accessFilters.includes("company"),
                      },
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.toggleAccessFilter("company")
                        },
                      },
                    },
                    [_vm._v("\n              My Company\n            ")]
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body gallery-modal__body" }, [
              _vm.isLoading
                ? _c("div", { staticClass: "gallery-modal__state" }, [
                    _c("span", {
                      staticClass: "spinner-border text-primary",
                      attrs: { role: "status" },
                    }),
                    _vm._v(" "),
                    _c("p", { staticClass: "mt-2 text-muted small" }, [
                      _vm._v("\n            Loading templates…\n          "),
                    ]),
                  ])
                : _vm.error
                ? _c("div", { staticClass: "gallery-modal__state" }, [
                    _c("p", { staticClass: "text-danger" }, [
                      _vm._v(
                        "\n            " + _vm._s(_vm.error) + "\n          "
                      ),
                    ]),
                  ])
                : _vm.filteredTemplates.length === 0
                ? _c("div", { staticClass: "gallery-modal__state" }, [
                    _c("p", { staticClass: "text-muted" }, [
                      _vm._v("\n            No templates found.\n          "),
                    ]),
                  ])
                : _c(
                    "div",
                    { staticClass: "gallery-modal__grid" },
                    _vm._l(_vm.filteredTemplates, function (tpl) {
                      return _c(
                        "div",
                        {
                          key: tpl.id,
                          staticClass: "gallery-card",
                          class: {
                            "gallery-card--selected": _vm.isSelected(tpl.id),
                          },
                          attrs: {
                            role: "button",
                            tabindex: "0",
                            "aria-pressed": _vm.isSelected(tpl.id)
                              ? "true"
                              : "false",
                            "aria-label": tpl.name,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.toggleTemplate(tpl)
                            },
                            keydown: [
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                $event.preventDefault()
                                return _vm.toggleTemplate(tpl)
                              },
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "space",
                                    32,
                                    $event.key,
                                    [" ", "Spacebar"]
                                  )
                                )
                                  return null
                                $event.preventDefault()
                                return _vm.toggleTemplate(tpl)
                              },
                            ],
                          },
                        },
                        [
                          _c("div", { staticClass: "gallery-card__thumb" }, [
                            tpl.thumbnail
                              ? _c("img", {
                                  staticClass: "gallery-card__img",
                                  attrs: {
                                    src: tpl.thumbnail,
                                    alt: tpl.name,
                                    loading: "lazy",
                                  },
                                })
                              : _c(
                                  "span",
                                  { staticClass: "gallery-card__placeholder" },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(tpl.width || "?") +
                                        "×" +
                                        _vm._s(tpl.height || "?") +
                                        "\n              "
                                    ),
                                  ]
                                ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "gallery-card__name",
                              attrs: { title: tpl.name },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(tpl.name) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.isSelected(tpl.id)
                            ? _c(
                                "div",
                                {
                                  staticClass: "gallery-card__check",
                                  attrs: { "aria-hidden": "true" },
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      staticClass: "lucide lucide-check",
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "24",
                                        height: "24",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        "stroke-width": "2",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: { d: "M20 6 9 17l-5-5" },
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      )
                    }),
                    0
                  ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer gallery-modal__footer" }, [
              _c(
                "span",
                {
                  staticClass:
                    "gallery-modal__selection-count text-muted small",
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.selectedCount > 0
                          ? _vm.selectedCount + " selected"
                          : "0 selected"
                      ) +
                      "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "gallery-modal__footer-actions" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "button", "data-dismiss": "modal" },
                  },
                  [_vm._v("\n            Cancel\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: {
                      type: "button",
                      disabled: _vm.selectedCount === 0,
                    },
                    on: { click: _vm.onAdd },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.selectedCount > 0
                            ? "Add " + _vm.selectedCount
                            : "Add"
                        ) +
                        "\n          "
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "gallery-modal__header-top" }, [
      _c("div", { staticClass: "gallery-modal__title-row" }, [
        _c(
          "h5",
          {
            staticClass: "modal-title gallery-modal__title",
            attrs: { id: "galleryModalLabel" },
          },
          [_vm._v("\n              Add from Design Gallery\n            ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "close gallery-modal__close",
            attrs: {
              type: "button",
              "data-dismiss": "modal",
              "aria-label": "Close",
            },
          },
          [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
        ),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "gallery-modal__subtitle" }, [
        _vm._v(
          "\n            Pick one or more templates to add to this placement.\n          "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }